import { motion } from 'framer-motion';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { media } from '../../utils/media-queries';

const ValuesWrapper = ({ children, variants }) => {
  const { ref, inView } = useInView();

  return (
    <StyledValuesWrapper
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={inView ? 'show' : ''}
      transition={{ delay: 1 }}
    >
      {children}
    </StyledValuesWrapper>
  );
};

const StyledValuesWrapper = styled(motion.div)`
  grid-column: 1 / 13;
  display: flex;
  flex-wrap: wrap;

  @media ${media.M} {
    grid-column: 3 / 13;
  }
`;

ValuesWrapper.propTypes = {
  children: PropTypes.node,
  variants: PropTypes.object,
};

export default ValuesWrapper;
